import { render, staticRenderFns } from "./levelFivepagePPJS.vue?vue&type=template&id=461c7ffd&scoped=true&"
import script from "./levelFivepagePPJS.vue?vue&type=script&lang=js&"
export * from "./levelFivepagePPJS.vue?vue&type=script&lang=js&"
import style0 from "./levelFivepagePPJS.vue?vue&type=style&index=0&id=461c7ffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c7ffd",
  null
  
)

export default component.exports